import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export const useAllNotificationChatCounts = () => {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['all-notification-chat-counts'],
    queryFn: async (): Promise<Map<string, number>> => {
      const { data, error } = await supabase.rpc('get_unread_chat_counts', {
        p_user_id: user?.id ?? ''
      });

      if (error) {
        console.error('Error fetching unread chat counts:', error);
        return new Map();
      }

      const counts = new Map<string, number>();
      if (data) {
        for (const row of data as { notification_id: string; unread_count: number }[]) {
          counts.set(row.notification_id, Number(row.unread_count));
        }
      }
      return counts;
    },
    enabled: !!user?.id,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });

  return {
    unreadCounts: data ?? new Map<string, number>(),
    isLoading,
    getUnreadCount: (notificationId: string) => data?.get(notificationId) ?? 0,
  };
};
